import React from 'react';
import { Badge as BootstrapBadge } from 'react-bootstrap';

const Badge = ({ 
    children, 
    bg = 'primary', 
    pill = false, 
    text,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapBadge 
            bg={bg} 
            pill={pill} 
            text={text}
            className={className} 
            style={style}
            {...props}
        >
            {children}
        </BootstrapBadge>
    );
};

export default Badge;

